/* global axios */
import WhatsAppSipApiClient from './index';

// Leitura das URAs publicadas. Escrita = publish atômico do fluxo
// (ivrFlows API), não CRUD granular.
class WhatsAppSipIvrsAPI extends WhatsAppSipApiClient {
  constructor() {
    super('ivrs');
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}`);
  }

  listOptions(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}/options`);
  }
}

export default new WhatsAppSipIvrsAPI();
